import { Component, OnInit, AfterViewInit } from '@angular/core';
import { CrudService } from '../crud.service';


// lightgallery
import 'lg-zoom.js';
import 'lg-share.js';
import 'lg-video.js';
import 'lg-pager.js';
import 'lg-autoplay.js';
import 'lg-fullscreen.js';
import 'lg-hash.js';
import 'lg-thumbnail.js';
declare let $: any;
declare var lightGallery: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit {
  elementRef: any;

  constructor(private crudService: CrudService) {

  }

  baseUrl = this.crudService.baseUrl;
  baseUrl1 = this.crudService.baseUrl1;

  ngOnInit(): void {}

  ngAfterViewInit() {
    $('#courses').owlCarousel({
      loop: true,
      nav: true,
      margin: 20,
      responsiveClass: true,
      autoplay: false,
      dots: false,
      navText: ["<div class='owl-prev'style='background:transparent;font-size:1.5rem;color:#5C0F8B;position:absolute;top:40%;left:-44px;'>‹</div>", "<div class='owl-next'style='background:transparent;font-size:1.5rem;color:#5C0F8B;position:absolute;top:40%;right:-44px;'>›</div>"],
      responsive: {
        320: {
          items: 2,
          margin: 1,
          nav: false,
          autoplay: true,
          animateOut: 'slideInLeft',
          animateIn: 'slideOutRight',
        },
        768: {
          items: 3,
        },
        1024: {
          items: 4,
          mouseDrag: false,  // disable dragging with mouse
          touchDrag: false,  // disable touch swipe
          pullDrag: false,   // disable grabbing effect
        }
      }
    });
    $('#courses1').owlCarousel({
      loop: true,
      nav: true,
      margin: 20,
      responsiveClass: true,
      autoplay: false,
      dots: false,
      // autoWidth: true,
      navText: ["<div class='owl-prev'style='background:transparent;font-size:1.5rem;color:#5C0F8B;position:absolute;top:40%;left:-44px;'>‹</div>", "<div class='owl-next'style='background:transparent;font-size:1.5rem;color:#5C0F8B;position:absolute;top:40%;right:-44px;'>›</div>"],
      responsive: {
        320: {
          items: 2,
          margin: 1,
          nav: false,
          autoplay: true,
          animateOut: 'slideInLeft',
          animateIn: 'slideOutRight',
        },
        768: {
          items: 3,
        },
        1024: {
          items: 4,
          loop: false,
          mouseDrag: false,  // disable dragging with mouse
          touchDrag: false,  // disable touch swipe
          pullDrag: false,   // disable grabbing effect
        }
      }
    });
    $('#events').owlCarousel({
      loop: true,
      margin: 30,
      responsiveClass: true,
      nav: true,
      autoplay: false,
      dots: false,
      navText: ["<div class='owl-prev'style='background:transparent;font-size:2rem;color:#5C0F8B;position:absolute;bottom:-55px;right:42px;left:auto;border: 1px solid #5c0f8b;border-radius: 40px;width: 35px;height: 35px;line-height:20px;''>‹</div>",
        "<div class='owl-next'style='background:transparent;font-size:2rem;color:#5C0F8B;position:absolute;bottom:-55px;right:0px;left:auto;border: 1px solid #5c0f8b;border-radius: 40px;width: 35px;height: 35px;line-height:20px;'>›</div>"],
      responsive: {
        320: {
          items: 2,
          nav: false,
          autoplay: true,
        },
        768: {
          items: 3
        },
        1024: {
          items: 3,
          mouseDrag: false,  // disable dragging with mouse
          touchDrag: false,  // disable touch swipe
          pullDrag: false,   // disable grabbing effect
        }
      }
    });
    $('#testimonials').owlCarousel({
      loop: true,
      margin: 10,
      responsiveClass: true,
      autoplay: false,
      nav: true,
      dots: false,
      navText: ["<div class='owl-prev'style='background:transparent;font-size:1.5rem;color:#5C0F8B;position:absolute;top:40%;left:-44px;'>‹</div>", "<div class='owl-next'style='background:transparent;font-size:1.5rem;color:#5C0F8B;position:absolute;top:40%;right:-44px;'>›</div>"],
      responsive: {
        0: {
          items: 1,
          nav: false,
          autoplay: true,
        },
        600: {
          items: 1
        },
        1000: {
          items: 1,
          dots: false,
          mouseDrag: false,  // disable dragging with mouse
          touchDrag: false,  // disable touch swipe
          pullDrag: false,   // disable grabbing effect
        }
      }
    });
    $('#news').owlCarousel({
      loop: true,
      margin: 20,
      responsiveClass: true,
      autoplay: false,
      nav: true,
      dots: false,
      navText: ["<div class='owl-prev'style='background:transparent;font-size:1.5rem;color:#5C0F8B;position:absolute;top:40%;left:-44px;'>‹</div>", "<div class='owl-next'style='background:transparent;font-size:1.5rem;color:#5C0F8B;position:absolute;top:40%;right:-44px;'>›</div>"],
      responsive: {
        0: {
          items: 2,
          nav: false,
          autoplay: true,
          margin: 0
        },
        600: {
          items: 3.3
        },
        1000: {
          items: 3,
          mouseDrag: false,  // disable dragging with mouse
          touchDrag: false,  // disable touch swipe
          pullDrag: false,   // disable grabbing effect
        }
      }
    });
    $('#upcoming-news').owlCarousel({
      loop: false,
      margin: 0,
      responsiveClass: true,
      autoplay: false,
      nav: true,
      dots: false,
      mouseDrag: false,  // disable dragging with mouse
      touchDrag: false,  // disable touch swipe
      pullDrag: false,   // disable grabbing effect
      navText: ["<div class='owl-prev'style='background:transparent;font-size:1.5rem;color:#5C0F8B;position:absolute;top:40%;left:-44px;'>‹</div>", "<div class='owl-next'style='background:transparent;font-size:1.5rem;color:#5C0F8B;position:absolute;top:40%;right:-44px;'>›</div>"],
      responsive: {
        0: {
          items: 1,
          nav: false,
          autoplay: true,
          margin: 0
        },
        600: {
          items: 1
        },
        1000: {
          items: 3,

        }
      }
    });
    $('#news-1').owlCarousel({
      loop: false,
      margin: 20,
      responsiveClass: true,
      autoplay: false,
      nav: true,
      dots: false,
      navText: ["<div class='owl-prev'style='background:transparent;font-size:1.5rem;color:#5C0F8B;position:absolute;top:40%;left:-44px;'>‹</div>", "<div class='owl-next'style='background:transparent;font-size:1.5rem;color:#5C0F8B;position:absolute;top:40%;right:-44px;'>›</div>"],
      responsive: {
        0: {
          items: 2,
          nav: false,
          autoplay: true,
          margin: 0
        },
        600: {
          items: 2
        },
        1000: {
          items: 3,
          mouseDrag: false,  // disable dragging with mouse
          touchDrag: false,  // disable touch swipe
          pullDrag: false,   // disable grabbing effect
        }
      }
    });
    $('#recruiters').owlCarousel({
      loop: true,
      margin: 0,
      responsiveClass: true,
      autoplay: true,
      nav: false,
      dots: false,
      responsive: {
        320: {
          items: 1,
          margin: 0,
        },
        768: {
          items: 1,
          margin: 0,
        },
        1024: {
          items: 1,
          margin: 0,
          mouseDrag: false,  // disable dragging with mouse
          touchDrag: false,  // disable touch swipe
          pullDrag: false,   // disable grabbing effect
        }
      }
    });

    //Init the carousel
    // initSlider();

    // function initSlider() {
    //   $("#banner").owlCarousel({
    //     items: 1,
    //     loop: true,
    //     autoplay: true,
    //     dots:false,
    //     onInitialized: startProgressBar,
    //     onTranslate: resetProgressBar,
    //     onTranslated: startProgressBar
    //   });
    // }

    // function startProgressBar() {
    //   // apply keyframe animation
    //   $(".slide-progress").css({
    //     width: "100%",
    //     transition: "width 5000ms"
    //   });
    // }

    // function resetProgressBar() {
    //   $(".slide-progress").css({
    //     width: 0,
    //     transition: "width 0s"
    //   });
    // }

    $('#onloadModal').modal('show');
    //   $(window).on('load',function(){

    //  });


    setTimeout(() => {
      /*---------------------------
      :: lightBox Gallery
      -----------------------------*/
      let galerias = document.getElementsByClassName('video-gallery');
      for (let i = 0; i < galerias.length; i++) {
        galerias[i].id = 'gal' + i;
        lightGallery(document.getElementById('gal' + i), {
          selector: 'a',
        });
      }

      let galImage = document.getElementsByClassName('lightgallery');

      for (const gal of galImage) {
        lightGallery(gal), {
          selector: 'a',
        }
      }
    }, 3000);

  }// after-view-init





}
